import * as types from "./ai_actionTypes";

const initialState = {
    AisearchedContacts: [],
    viewedContacts: [],
    
    loading: true,
};

const aiApolloReducers = (state = initialState, action) => {
    switch (action.type) {
        
        case types.get_AI_Contact_Data_Update:
            return {
                ...state,
                AisearchedContacts: action.payload,
                loading: false,
            };

        case types.get_AI_Contact_Data:
            // return {
            //     ...state,
            //     AisearchedContacts: action.payload.length === 0
            //         ? []
            //         : action.payload.reduce((acc, newItem) => {
            //             const index = acc.findIndex(
            //                 item => item.id === newItem.id
            //             );

            //             if (index !== -1) {
            //                 acc[index] = {
            //                     ...acc[index],
            //                     ...newItem
            //                 };
            //             } else {
            //                 acc.push(newItem);
            //             }

            //             return acc;
            //         }, [...state.AisearchedContacts]),
            //     loading: false
            // };
            return {
                ...state,
                AisearchedContacts: action.payload.length === 0
                    ? []
                    : [
                        ...state.AisearchedContacts,
                        ...action.payload
                    ],
                loading: false,
            };
        case types.get_Viedwed_Contact_Data:
            return {
                ...state,
                viewedContacts: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export default aiApolloReducers;